/**
 * Get columns for a specific depth level.
 * Returns only explicit level overrides — does NOT fall back to config.default.
 * The caller (report-compiler) handles the default fallback separately,
 * after checking the bound column_headers row first.
 */
export function getColumnsForLevel(config, depth) {
    return config.levels[depth] ?? [];
}
/**
 * Create a LevelColumnConfig from an existing flat column array.
 * Used during migration from flat columns to level-based config.
 */
export function createDefaultLevelConfig(columns) {
    return { default: columns, levels: {} };
}
//# sourceMappingURL=column-config-utils.js.map